// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/content-cards/content-cards';
import 'sections/icon-block/icon-block';
import 'sections/banner/banner-block';
import 'sections/faqs/faqs';
import 'sections/tabs/tabs';
import 'sections/collection-list/collection-list';
import 'sections/featured-collection/featured-collection';
import 'sections/featured-products/featured-products';
import 'sections/blog-posts/blog-posts';
import 'sections/related-blogs/related-blogs';
import 'sections/newsletter/newsletter';
import 'sections/main-blog/main-blog';
import 'sections/page-header/page-header';
import 'sections/rich-text/rich-text';
import 'sections/scrolling-product-content/scrolling-product-content';
import 'sections/ticker-bar/ticker-bar';
import 'sections/dispenser-banner/dispenser-banner';
import 'sections/statement-block/statement-block';
import 'sections/product-hotspots/product-hotspots';
import 'sections/lever/lever';
import 'sections/featured-product/featured-product';
import 'sections/press-block/press-block';
import 'sections/footer/footer';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/comparison-chart/comparison-chart';
import 'sections/size-guidance/size-guidance';
import 'sections/price-spider/price-spider';
import 'sections/quiz-results/quiz-results';
import 'sections/quiz-results-header/quiz-results-header';
import 'sections/media-block/media-block';
import 'sections/ugc-testimonials/ugc-testimonials';
import 'sections/shop-carousel/shop-carousel';

// Styles
import './_pages.scss';
